import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { DashboardReport } from '../models';

@Injectable({ providedIn: 'root' })
export class DashboardService extends EntityCollectionServiceBase<DashboardReport> {
    [name: string]: any;
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('DashboardReport', serviceElementsFactory);
    }
}
